<template>
  <section id="recruit" class="rt-section recruit">
    <div class="rt-inner recruit__inner">
      <span class="rt-eyebrow recruit__eyebrow">RECRUIT</span>
      <h2 class="recruit__title">いっしょに、音楽の裏側をつくる人へ。</h2>
      <p class="recruit__lead">
        現在募集中の職種はありませんが、ご興味のある方はお気軽にご連絡ください。
      </p>
      <router-link to="/inquiry" class="rt-btn rt-btn--ink">お問い合わせ</router-link>
    </div>
  </section>
</template>

<script>
export default { name: 'HomeRecruit' }
</script>

<style scoped>
.recruit {
  background: linear-gradient(135deg, var(--pink-bg), var(--blue-bg));
}

.recruit__inner {
  text-align: center;
}

.recruit__eyebrow {
  color: var(--brand-pink);
  background: #fff;
}

.recruit__title {
  font-size: clamp(20px, 4vw, 24px);
  font-weight: 700;
  color: var(--ink);
}

.recruit__lead {
  font-size: 14px;
  line-height: 1.9;
  color: var(--ink-soft);
  max-width: 460px;
  margin: 12px auto 20px;
}
</style>
